import { Box } from '@mui/material';
import ChipItem from './ChipItem';
import { ChipListItem } from './chipList.types';

interface Props {
  items: ChipListItem[];
}

const WrappedChipList = ({ items }: Props) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 0.5,
      padding: 0.5,
      maxWidth: '100%',
      minWidth: 0,
      '& > *': { minWidth: 0 },
    }}
  >
    {items.map((item) => (
      <ChipItem key={item.key} item={item} isShrinkable />
    ))}
  </Box>
);

export default WrappedChipList;
